export function cadastreFormat(value, maxLength) {
    if (value && (maxLength ? value.toString().length < maxLength : true)) {
        let digitValue = value.toString().replaceAll(/\D+/g, "").substring(0, 21)
        let formattedValue = ""
        let firstPart = digitValue.match(/.{0,4}/g)
        digitValue = digitValue.slice(4)
        let secondPart = digitValue.match(/.{0,6}/g)
        digitValue = digitValue.slice(6)
        let thirdPart = digitValue.match(/.{0,4}/g)
        digitValue = digitValue.slice(4)
        let fourthPart = digitValue.match(/.{0,7}/g)
        if (firstPart.length > 1) {
            formattedValue = firstPart[0].match(/.{1,2}/g).join(":")
            if (secondPart.length > 1) {
                if(thirdPart.length > 1 && thirdPart[0].length <= 3) {
                    formattedValue += `:${secondPart[0]}`
                    formattedValue += thirdPart[0]
                } else if(thirdPart.length > 1 && thirdPart[0].length > 3) {
                    formattedValue += `:${secondPart[0].match(/.{1,2}/g).join(":")}`
                    formattedValue += `:${thirdPart[0]}`
                    if(fourthPart.length > 1) {
                        if (fourthPart[0].length === 1) {
                            formattedValue += fourthPart[0]
                        } else if (fourthPart[0].length === 2 || fourthPart[0].length === 4) {
                            let the20ThSign = value.toString().slice(19, 20)
                            let isSignSlashOrColon = fourthPart[0].length === 4 && (the20ThSign === ':' || the20ThSign === '/')
                            formattedValue += isSignSlashOrColon
                                ? `${the20ThSign}${fourthPart[0]}`
                                : `/${fourthPart[0]}`
                        } else if (fourthPart[0].length === 3 || fourthPart[0].length === 5) {
                            formattedValue += `${fourthPart[0].slice(0, 1)}/${fourthPart[0].slice(1)}`
                        } else if (fourthPart[0].length > 5) {
                            formattedValue += `:${fourthPart[0].match(/.{1,4}/g).join(":")}`
                        }
                    }
                } else {
                    formattedValue += `:${secondPart[0]}`
                }
            }
        }
        return formattedValue
    }
    return ""
}
